import secureLocalStorage from "react-secure-storage";

const FILTER_STATE_KEY = "filter-selections";

export const persistFilterState = (storeAPI) => (next) => (action) => {
  const result = next(action);

  const filterActions = [
    "filter/setSelectedState",
    "filter/setSelectedCounty",
    "filter/setSelectedFips",
    "filter/setLandCoverSelections",
    "filter/setPrioritySelections",
    "filter/setRankingScore",
    "filter/resetSelections",
  ];

  if (filterActions.includes(action.type)) {
    const filterState = storeAPI.getState().filter;
    secureLocalStorage.setItem(FILTER_STATE_KEY, filterState);
  }

  return result;
};
